import * as React from "react";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik, useFormikContext } from "formik";
import {
  Autocomplete,
  createTheme,
  Divider,
  FormHelperText,
  IconButton,
  TextField,
  ThemeProvider,
  Typography,
  useTheme,
  Grid,
  Grid2,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  FormControlLabel,
  Switch,
} from "@mui/material";
import * as Yup from "yup";
import { useState } from "react";
import {
  useGetPackagesQuery,
  useLazyGetPackagesQuery,
} from "store/slices/apis/packageSlice";
import { useGetContractorQuery } from "store/slices/apis/contractors";
import { IoMdClose } from "react-icons/io";
import { useAddKeyRiskMutation } from "store/slices/apis/keyRiskSlice";
import { useNavigate, useParams } from "react-router-dom";
import DragAndDropUpload from "components/FileUploader/DragAndDropUpload";
import { FaRegFileLines } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useGetAllSettingsQuery } from "store/slices/apis/projectSettingsSlice";
import { useGetAllWorkflowQuery } from "store/slices/apis/workflowSlice";
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const Statuses = [
  { label: "Open", value: "open" },
  { label: "Close", value: "close" },
];

const scores = [
  { label: "1 (Negligible)", value: 1 },
  { label: "2 (Low)", value: 2 },
  { label: "3 (Moderate)", value: 3 },
  { label: "4 (High)", value: 4 },
  { label: "5 (Extreme)", value: 5 },
];

export default function AddRisk(props) {
  const { open, cancelIssue, openNotification, refetch } = props;
  const newtheme = useTheme();
  const { projectId } = useParams();
  const navigate = useNavigate();
  const { data: packages } = useGetPackagesQuery({ projectId: projectId });
  const { data: contractors } = useGetContractorQuery();
  const [getSubPackage1, { data: subPackageList1 }] = useLazyGetPackagesQuery();
  const [getSubPackage2, { data: subPackageList2 }] = useLazyGetPackagesQuery();
  // const [getSubPackage3, { data: subPackageList3 }] = useLazyGetPackagesQuery();
  // const [getSubPackage4, { data: subPackageList4 }] = useLazyGetPackagesQuery();
  // const [getSubPackage5, { data: subPackageList5 }] = useLazyGetPackagesQuery();
  // const [getSubPackage6, { data: subPackageList6 }] = useLazyGetPackagesQuery();
  // const [getSubPackage7, { data: subPackageList7 }] = useLazyGetPackagesQuery();
  const [files, setFiles] = useState([]);
  const [dense, setDense] = useState(false);
  const [secondary, setSecondary] = useState(false);
  const { data: allSettings } = useGetAllSettingsQuery({
    ProjectId: projectId,
    name: "",
  });
  const workflowList = useGetAllWorkflowQuery({ projectId, pageNumber: 1, pageSize: 100, entityName: 'Risk' })

  const [
    addKeyRisk,
    { data: addKeyIssueRes, isLoading, isSuccess, isError, error },
  ] = useAddKeyRiskMutation();

  const [formData, setFormData] = useState({
    contractor: "",
    package: "",
    subPackage1: "",
    subPackage2: "",
    // subPackage3: "",
    // subPackage4: "",
    // subPackage5: "",
    // subPackage6: "",
    // subPackage7: "",
    mitigation: null,
    risk_reporting_date: "",
    riskCategory: "",
    riskDescription: "",
    rootCauses: "",
    likelihoodScore: "",
    impactScoreQuality: "",
    impactScoreSchedule: "",
    impactScoreCost: "",
    impactScoreOverall: "",
    status: "",
    riskScore: "",
    severity: "",
    inherent: false,
    WorkflowApprovalId: ""
  });

  const AutoCalculateImpact = () => {
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
      const maxValue = Math.max(
        Number(values.impactScoreQuality) || 0,
        Number(values.impactScoreSchedule) || 0,
        Number(values.impactScoreCost) || 0
      );

      setFieldValue("impactScoreOverall", maxValue);
    }, [
      values.impactScoreQuality,
      values.impactScoreSchedule,
      values.impactScoreCost,
      setFieldValue,
    ]);

    return null;
  };


  const CustomCalendarIcon = (props) => (
    <CalendarIcon {...props} style={{ width: 26, height: 26, fill: "#696969 ", stroke: "#696969", strokeWidth: 4 }} />
  );

  const riskCategoryOptions =
    allSettings?.data?.find(
      (item) => item?.name?.toLowerCase() === "risk category".toLowerCase()
    )?.items || [];

  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: "2px solid #e6e6e6",
            "& .MuiFilledInput-input": {
              backgroundColor: "#fff",
              color: "#252525",
              fontSize: "16px",
            },
            "& .MuiFilledInput-root::before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root::after": {
              borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#696969",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              fontSize: "15px",
            },
            "& .MuiFilledInput-root.Mui-disabled:before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: "none",
              fontSize: "14px",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#696969",
            },
            "& .MuiFilledInput-root.Mui-disabled": {
              backgroundColor: "#fff",
              color: "inherit",
            },
            "& .MuiFilledInput-input.Mui-disabled": {
              WebkitTextFillColor: "#696969",
              opacity: "none",
            },
          },
        },
      },
    },
  });

  const handleClose = () => { };

  const validationSchema = Yup.object({
    // contractor: Yup.string().required("Contractor is required"),
    package: Yup.string().required("Category is required"),
    subPackage1: Yup.string().required("Sub Category 1 is required"),
    subPackage2: Yup.string().required("Sub Category 2 is required"),
    // subPackage3: Yup.string().required("Sub Category 3 field is required."),
    // subPackage4: Yup.string().required("Sub Category 4 field is required."),
    // subPackage5: Yup.string().required("Sub Category 5 field is required."),
    // subPackage6: Yup.string().required("Sub Category 6 field is required."),
    // subPackage7: Yup.string().required("Sub Category 7 field is required."),
    risk_reporting_date: Yup.date()
      .required("Risk Reporting Date is required")
      .nullable()
      .typeError("Risk Reporting Date must be a valid date"),
    riskCategory: Yup.string().required("Risk Category is required"),
    riskDescription: Yup.string().required("Risk Description is required"),
    rootCauses: Yup.string().required("Root Causes are required"),
    likelihoodScore: Yup.number().required("Likelihood Score is required"),
    impactScoreQuality: Yup.number().required(
      "Impact Score Quality is required"
    ),
    impactScoreSchedule: Yup.number().required(
      "Impact Score Schedule is required"
    ),
    impactScoreCost: Yup.number().required("Impact Score Cost is required"),
    impactScoreOverall: Yup.number().required(
      "Impact Score Overall is required"
    ),
    status: Yup.string().required("Status is required"),
    WorkflowApprovalId: Yup.string().required("Workflow field is required"),
  });

  const handleDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      openNotification("File type must be image/*");
      return;
    }
    const newFiles = acceptedFiles.filter(
      (file) => !files.some((f) => f.name === file.name)
    );

    if (newFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleRemoveFile = (fileName) => {
    setFiles(files.filter((file) => file.name !== fileName));
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const riskScore =
      values?.likelihoodScore * values?.impactScoreOverall || null;

    const severity = (() => {
      if (!riskScore) return "";
      if (riskScore >= 1 && riskScore <= 5) return "Low";
      if (riskScore >= 6 && riskScore <= 14) return "Moderate";
      if (riskScore >= 15 && riskScore <= 25) return "Critical";
      return "";
    })();

    let reqBody = {
      contractor: values?.contractor,
      package: values?.package,
      sub_package_1: values?.subPackage1,
      sub_package_2: values?.subPackage2,
      // sub_package_3: values.subPackage3,
      // sub_package_4: values.subPackage4,
      // sub_package_5: values.subPackage5,
      // sub_package_6: values.subPackage6,
      // sub_package_7: values.subPackage7,
      mitigation: values?.mitigation,
      risk_reporting_date:
        values?.risk_reporting_date &&
          dayjs(values.risk_reporting_date).isValid()
          ? dayjs(values.risk_reporting_date).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      risk_category: values?.riskCategory,
      risk_description: values?.riskDescription,
      root_causes: values?.rootCauses,
      likelihood_score: values?.likelihoodScore,
      impact_score_quality: values?.impactScoreQuality,
      impact_score_schedule: values?.impactScoreSchedule,
      impact_score_cost: values?.impactScoreCost,
      impact_score_overall: values?.impactScoreOverall,
      status: values?.status,
      risk_score: riskScore,
      severity: severity,
      // inherent: values?.inherent || false,
      ProjectId: projectId,
      WorkflowApprovalId: values?.WorkflowApprovalId
    };

    try {
      const formData = new FormData();
      formData.append("riskJson", JSON.stringify(reqBody));
      formData.append("file", files);
      const response = await addKeyRisk(formData).unwrap();
      if (response?.status == "Success") {
        openNotification(
          response?.message || "Risk created successfully",
          "success"
        );
        resetForm();
        refetch();
        cancelIssue();
        navigate(`/projects/${projectId}/key-risk/risk-submitted-by-me`);
      } else {
        openNotification("Error in risk creation");
      }
    } catch (error) {
      openNotification(error?.error, "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            overflowY: "inherit",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "20px", color: "#696969" }}>
          Add New Risk
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancelIssue}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
          <CrossIcon style={{ fontSize: "20px", width: "20px", height: "20px", fill: "#808080" }} />
        </IconButton>
        <Divider sx={{ w: 1 }} />
        <DialogContent>
          <ThemeProvider theme={theme}>
            <Box sx={{ mt: 1 }}>
              <Formik
                initialValues={formData}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  setTouched,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <AutoCalculateImpact />
                    <Grid2 container spacing={2}>
                      <Grid2 size={12}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          sx={{ fontSize: "20px", color: "#252525" }}
                        >
                          Select Categories
                        </Typography>
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 6 }}>
                        <Autocomplete
                          options={(packages?.data || [])?.filter(
                            (option) => option
                          )}
                          getOptionLabel={(option) => option}
                          value={
                            packages?.data?.find(
                              (option) => option === values?.package
                            ) || null
                          }
                          onChange={(_, newValue) => {
                            setFieldValue(
                              "package",
                              newValue ? newValue : ""
                            );
                            setFieldValue("subPackage1", "");
                            setFieldValue("subPackage2", "");
                            // setFieldValue("subPackage3", "");
                            // setFieldValue("subPackage4", "");
                            // setFieldValue("subPackage5", "");
                            // setFieldValue("subPackage6", "");
                            // setFieldValue("subPackage7", "");
                            getSubPackage1({
                              projectId: projectId,
                              type: "subPackage1",
                            });
                          }}
                          onBlur={() =>
                            setTouched({ ...touched, package: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Category"
                              name="package"
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.package && errors?.package && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.package}`}</FormHelperText>
                        )}
                      </Grid2>
                      {values?.package && (
                        <Grid2 size={{ xs: 12, md: 6 }}>
                          <Autocomplete
                            options={subPackageList1?.data}
                            getOptionLabel={(option) => option}
                            value={
                              subPackageList1?.data?.find(
                                (option) =>
                                  option === values?.subPackage1
                              ) || null
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage1",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage2", "");
                              // setFieldValue("subPackage3", "");
                              // setFieldValue("subPackage4", "");
                              // setFieldValue("subPackage5", "");
                              // setFieldValue("subPackage6", "");
                              // setFieldValue("subPackage7", "");
                              getSubPackage2({
                                projectId: projectId,
                                type: "subPackage2",
                              });
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage1: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 1"
                                name="subPackage1"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage1 && errors?.subPackage1 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage1}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}
                      {values?.subPackage1 && (
                        <Grid2 size={{ xs: 12, md: 6 }}>
                          <Autocomplete
                            options={subPackageList2?.data}
                            getOptionLabel={(option) => option}
                            value={
                              subPackageList2?.data?.find(
                                (option) =>
                                  option === values?.subPackage2
                              ) || null
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage2",
                                newValue ? newValue : ""
                              );
                              // setFieldValue("subPackage3", "");
                              // setFieldValue("subPackage4", "");
                              // setFieldValue("subPackage5", "");
                              // setFieldValue("subPackage6", "");
                              // setFieldValue("subPackage7", "");
                              // getSubPackage3({
                              //   projectId: projectId,
                              //   type: "subPackage3",
                              // });
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage2: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 2"
                                name="subPackage2"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage2 && errors?.subPackage2 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage2}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}
                      {/* {values?.subPackage2 && (
                        <Grid2 size={6}>
                          <Autocomplete
                            options={(subPackageList3?.data || [])?.filter(
                              (option) => option
                            )}
                            getOptionLabel={(option) =>
                              option || ""
                            }
                            value={
                              subPackageList3?.data?.find(
                                (option) =>
                                  option === values?.subPackage3
                              ) || ""
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage3",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage4", "");
                              setFieldValue("subPackage5", "");
                              setFieldValue("subPackage6", "");
                              setFieldValue("subPackage7", "");
                              getSubPackage4({
                                projectId: projectId,
                                type: "subPackage4",
                              });
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage3: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 3"
                                name="subPackage3"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage3 && errors?.subPackage3 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage3}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}
                      {values?.subPackage3 && (
                        <Grid2 size={6}>
                          <Autocomplete
                            options={(subPackageList4?.data || [])?.filter(
                              (option) => option
                            )}
                            getOptionLabel={(option) =>
                              option || ""
                            }
                            value={
                              subPackageList4?.data?.find(
                                (option) =>
                                  option === values?.subPackage4
                              ) || ""
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage4",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage5", "");
                              setFieldValue("subPackage6", "");
                              setFieldValue("subPackage7", "");
                              getSubPackage5({
                                projectId: projectId,
                                type: "subPackage5",
                              });
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage4: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 4"
                                name="subPackage4"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage4 && errors?.subPackage4 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage4}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}

                      {values?.subPackage4 && (
                        <Grid2 size={6}>
                          <Autocomplete
                            options={(subPackageList5?.data || [])?.filter(
                              (option) => option
                            )}
                            getOptionLabel={(option) =>
                              option || ""
                            }
                            value={
                              subPackageList5?.data?.find(
                                (option) =>
                                  option === values?.subPackage5
                              ) || ""
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage5",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage6", "");
                              setFieldValue("subPackage7", "");
                              getSubPackage6({
                                projectId: projectId,
                                type: "subPackage6",
                              });
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage5: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 5"
                                name="subPackage5"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage5 && errors?.subPackage5 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage5}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}

                      {values?.subPackage5 && (
                        <Grid2 size={6}>
                          <Autocomplete
                            options={(subPackageList6?.data || [])?.filter(
                              (option) => option
                            )}
                            getOptionLabel={(option) =>
                              option || ""
                            }
                            value={
                              subPackageList6?.data?.find(
                                (option) =>
                                  option === values?.subPackage6
                              ) || ""
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage6",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage7", "");
                              getSubPackage7({
                                projectId: projectId,
                                type: "subPackage7",
                              });
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage6: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 6"
                                name="subPackage6"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage6 && errors?.subPackage6 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage6}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}

                      {values?.subPackage6 && (
                        <Grid2 size={6}>
                          <Autocomplete
                            options={(subPackageList7?.data || [])?.filter(
                              (option) => option
                            )}
                            getOptionLabel={(option) =>
                              option || ""
                            }
                            value={
                              subPackageList7?.data?.find(
                                (option) =>
                                  option === values?.subPackage7
                              ) || ""
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage7",
                                newValue ? newValue : ""
                              );
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage7: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 7"
                                name="subPackage7"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage7 && errors?.subPackage7 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage7}`}</FormHelperText>
                          )}
                        </Grid2>
                      )} */}
                    </Grid2>

                    <Divider
                      sx={{
                        width: "100%",
                        mb: 2,
                        mt: 2,
                        borderBottomWidth: "medium",
                      }}
                    />

                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Box display="flex" alignItems="center" gap="20px">
                          <Typography
                            variant="h4"
                            gutterBottom
                            sx={{ fontSize: "20px", color: "#252525" }}
                          >
                            Enter Risk Details
                          </Typography>

                          {/* <FormControlLabel
                            control={
                              <Switch
                                name="inherent"
                                size="small"
                                checked={values?.inherent || false}
                                onChange={(e) =>
                                  setFieldValue("inherent", e.target.checked)
                                }
                              />
                            }
                            label="Inherent"
                            sx={{ marginBottom: "8px" }}
                          /> */}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={workflowList?.data?.data || []}
                          getOptionLabel={(option) => option?.workflowName}
                          value={workflowList?.data?.data?.find((option) => option?.id === values?.WorkflowApprovalId) || null}
                          onChange={(_, newValue) => setFieldValue("WorkflowApprovalId", newValue ? newValue?.id : "")}
                          onBlur={() => setTouched({ ...touched, WorkflowApprovalId: true })}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Workflow"
                              placeholder='Select Workflow'
                              name="WorkflowApprovalId"
                              // slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.WorkflowApprovalId && errors?.WorkflowApprovalId &&
                          <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.WorkflowApprovalId}`}</FormHelperText>
                        }
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={contractors?.data}
                          getOptionLabel={(option) => option.name}
                          value={
                            contractors?.data.find(
                              (option) => option.id === values.contractor
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "contractor",
                              newValue ? newValue.id : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, contractor: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Consultant/Contractor"
                              name="contractor"
                              // slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.contractor && errors?.contractor && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.contractor}`}</FormHelperText>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Mitigation"
                          name="mitigation"
                          fullWidth
                          value={values?.mitigation}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, mitigation: true })
                          }
                          variant="filled"
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Risk Reporting Date"
                            value={
                              values?.risk_reporting_date
                                ? dayjs(values.risk_reporting_date)
                                : null
                            }
                            format="DD-MM-YYYY"
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "risk_reporting_date",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                            slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                risk_reporting_date: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 16, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 16,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.risk_reporting_date &&
                            errors?.risk_reporting_date && (
                              <FormHelperText
                                sx={{ color: "#C52A1A", fontSize: "12px" }}
                              >{`${errors?.risk_reporting_date}`}</FormHelperText>
                            )}
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={riskCategoryOptions}
                          getOptionLabel={(option) => option?.value || ""}
                          value={
                            riskCategoryOptions.find(
                              (item) => item?.value === values.riskCategory
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "riskCategory",
                              newValue ? newValue?.value : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, riskCategory: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Risk Category"
                              name="riskCategory"
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.riskCategory && errors?.riskCategory && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.riskCategory}`}</FormHelperText>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Root Causes"
                          name="rootCauses"
                          fullWidth
                          value={values?.rootCauses}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, rootCauses: true })
                          }
                          variant="filled"
                        />
                        {touched?.rootCauses && errors?.rootCauses && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.rootCauses}`}</FormHelperText>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={scores}
                          getOptionLabel={(option) => option?.label}
                          value={
                            scores.find(
                              (option) =>
                                option.value === values?.likelihoodScore
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "likelihoodScore",
                              newValue ? newValue.value : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, status: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Likelihood"
                              name="likelihoodScore"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.likelihoodScore &&
                          errors?.likelihoodScore && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.likelihoodScore}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={scores}
                          getOptionLabel={(option) => option?.label}
                          value={
                            scores.find(
                              (option) =>
                                option.value === values?.impactScoreQuality
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "impactScoreQuality",
                              newValue ? newValue.value : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, status: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Impact Score Quality"
                              name="impactScoreQuality"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.impactScoreQuality &&
                          errors?.impactScoreQuality && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.impactScoreQuality}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={scores}
                          getOptionLabel={(option) => option?.label}
                          value={
                            scores.find(
                              (option) =>
                                option.value === values?.impactScoreSchedule
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "impactScoreSchedule",
                              newValue ? newValue.value : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, status: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Impact Score Schedule"
                              name="impactScoreSchedule"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.impactScoreSchedule &&
                          errors?.impactScoreSchedule && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.impactScoreSchedule}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={scores}
                          getOptionLabel={(option) => option?.label}
                          value={
                            scores.find(
                              (option) =>
                                option.value === values?.impactScoreCost
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "impactScoreCost",
                              newValue ? newValue.value : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, status: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Impact Score Cost"
                              name="impactScoreCost"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.impactScoreCost &&
                          errors?.impactScoreCost && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.impactScoreCost}`}</FormHelperText>
                          )}
                      </Grid>

                      {/* <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={scores}
                          getOptionLabel={(option) => option?.label}
                          value={
                            scores.find(
                              (option) =>
                                option.value === values?.impactScoreOverall
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "impactScoreOverall",
                              newValue ? newValue.value : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, status: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Impact Score Overall"
                              name="impactScoreOverall"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.impactScoreOverall &&
                          errors?.impactScoreOverall && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.impactScoreOverall}`}</FormHelperText>
                          )}
                      </Grid> */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Impact Score Overall"
                          value={values.impactScoreOverall}
                          variant="filled"
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Risk Score (Likelihood Score * Impact Score Overall)"
                          name="riskScore"
                          fullWidth
                          disabled
                          value={
                            values?.likelihoodScore *
                            values?.impactScoreOverall || ""
                          }
                          variant="filled"
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Severity"
                          name="severity"
                          fullWidth
                          disabled
                          value={(() => {
                            const riskScore =
                              values?.likelihoodScore *
                              values?.impactScoreOverall;
                            if (!riskScore) return "";
                            if (riskScore >= 1 && riskScore <= 5) return "Low";
                            if (riskScore >= 6 && riskScore <= 14)
                              return "Moderate";
                            if (riskScore >= 15 && riskScore <= 25)
                              return "Critical";
                            return "";
                          })()}
                          variant="filled"
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={Statuses}
                          getOptionLabel={(option) => option?.label}
                          value={
                            Statuses.find(
                              (option) => option.label === values?.status
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "status",
                              newValue ? newValue.label : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, status: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Status"
                              name="status"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.status && errors?.status && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.status}`}</FormHelperText>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Risk Description"
                          name="riskDescription"
                          fullWidth
                          multiline
                          value={values?.riskDescription}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, riskDescription: true })
                          }
                          variant="filled"
                        />
                        {touched?.riskDescription &&
                          errors?.riskDescription && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.riskDescription}`}</FormHelperText>
                          )}
                      </Grid>
                      <Grid item xs={12}>
                        {files.length > 0 && (
                          <>
                            <Typography
                              variant="h6"
                              gutterBottom
                              style={{
                                color: "#474747",
                                fontWeight: "400",
                                fontSize: "16px",
                              }}
                            >
                              Uploaded Files
                            </Typography>

                            <List dense>
                              {files.map((file, index) => (
                                <ListItem
                                  key={index}
                                  sx={{
                                    padding: 0,
                                  }}
                                  secondaryAction={
                                    <IconButton
                                      edge="end"
                                      aria-label="delete"
                                      onClick={() =>
                                        handleRemoveFile(file.name)
                                      }
                                    >
                                      <RxCross2 />
                                    </IconButton>
                                  }
                                >
                                  <ListItemAvatar>
                                    <Avatar sx={{ background: "none" }}>
                                      <FaRegFileLines
                                        fontSize="inherit"
                                        style={{ color: "#474747" }}
                                      />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText primary={`${file.name}`} />
                                </ListItem>
                              ))}
                            </List>
                          </>
                        )}
                      </Grid>

                      <Grid item xs={12}>
                        <DragAndDropUpload
                          onDrop={handleDrop}
                          multi={true}
                          fileType="both"
                        />
                      </Grid>

                      <Grid item xs={12}>
                        {/* <Button
                          onClick={cancelIssue}
                          variant="outlined"
                          sx={{
                            color: `${newtheme?.customSettings?.themeColor}`,
                            border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                            padding: "6px 20px",
                            fontWeight: "500",
                            textTransform: "none",
                            float: "right",
                            fontSize: "16px",
                          }}
                        >
                          Cancel
                        </Button> */}
                        <Button
                          type="submit"
                          loading={isLoading}
                          variant="contained"
                          sx={{
                            marginRight: "20px",
                            backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                            color: "#FFF",
                            padding: "6px 20px",
                            fontWeight: "500",
                            textTransform: "none",
                            float: "right",
                            fontSize: "16px",
                          }}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Box>
          </ThemeProvider>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
